import * as React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface IconProps {
  icon: React.ReactNode;
  type: 'naked' | 'dressed';
  iconStyle?: any;
  width?: number;
  height?: number;
  style?: any;
  stroke?: string;
  fillColor?: string;
}

export const Icon = ({
  type,
  icon,
  iconStyle,
  width,
  height,
  style,
  stroke,
  fillColor,
}: IconProps) => {
  const { styles, theme } = useStyles(stylesheet);

  const clonedIcon = React.isValidElement(icon)
    ? React.cloneElement(icon, {
        style: {
          // padding: 10, // TODO: native had padding 10 but web doesn't, handle
          flexShrink: 0,
          ...iconStyle,
        },
        width: width || 'auto',
        height: height || 'auto',
        color:
          type === 'naked'
            ? theme.colors.icon.nakedColor
            : theme.colors.icon.color,
        ...(fillColor ? { fill: fillColor } : {}),
        ...(stroke ? { stroke } : {}),
      })
    : icon;

  if (type === 'naked') {
    return clonedIcon;
  }

  return <View style={[styles.container, style]}>{clonedIcon}</View>;
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    backgroundColor: theme.colors.icon.fill,
    padding: 10,
    borderRadius: 8,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
